import { inject, Injectable, Injector, resource, Signal, signal } from '@angular/core';
import { FieldOkObjekt } from '@softapps/wws/core';
import { handleRequestError } from '@softline/application';
import { ApiResourceLocation, ConnectionHttpService } from '@softline/core';
import { FieldOkParameters, SOFTLINE_API_FIELD_OK_RESULT } from '@softline/dynamic';
import { firstValueFrom, map } from 'rxjs';

const OBJECT_FOK_PARAMS: FieldOkParameters = {
  filter: null,
  multiValued: false,
  parameters: {
    kzvkbranche: 'B',
  },
  maxAbfrageResults: 1000,
};

@Injectable()
export class ConstructionPartsObjectService {
  readonly #httpService = inject(ConnectionHttpService);
  readonly #id = signal<Signal<string | number | undefined>>(signal(undefined));
  readonly #injector = inject(Injector);

  readonly #object = resource<FieldOkObjekt | undefined, string | number | undefined>({
    params: () => this.#id()(),
    loader: async ({ params: objectId }) => {
      if (!objectId) {
        return Promise.resolve(undefined);
      }
      try {
        return firstValueFrom<FieldOkObjekt | undefined>(
          this.#httpService
            .create<
              FieldOkParameters,
              { data: FieldOkObjekt | null }
            >(this.apiLocation(objectId), OBJECT_FOK_PARAMS)
            .pipe(map((o) => o?.data ?? undefined))
        );
      } catch (e) {
        handleRequestError(e, this.#injector, { show: true });
        return undefined;
      }
    },
  });

  readonly object = this.#object.asReadonly();

  set(object: FieldOkObjekt): void {
    this.#object.set(object);
  }

  register(idSignal: Signal<string | number | undefined>): void {
    this.#id.set(idSignal);
  }

  private apiLocation(id: string | number): ApiResourceLocation {
    return {
      path: SOFTLINE_API_FIELD_OK_RESULT,
      pathParams: {
        fieldOk: 'objekt',
        key: id,
      },
    };
  }
}
